import Resource from '@/plugins/sdk/Resource'
import { STRING, UUID } from '@/plugins/sdk/fields'

export default class extends Resource {
  static name = 'dictionary_timecycle'

  static get fields () {
    return {
      id: new UUID(),
      short: new STRING(),
      long: new STRING()
    }
  }
}
